<template>
  <div>
    <a
      :download="decodeURI(fileName)"
      :target="blankOrDirect"
      :href="fileUrl"
    >
      {{ decodeURI(fileName) }}
    </a>
  </div>
</template>
<script>
import FileUsecase from "@/usecases/file.usecase";

export default {
  components: {},
  data () {
    return {
      fileUsecase: new FileUsecase(),
      fileName: null,
      blankOrDirect: null,
      fileUrl: null,
    };
  },
  props: {
    src: {
      type: String,
      default: "",
    },
  },
  async mounted () {
    await this.resolve(this.src);
  },
  watch: {
    src: async function (after) {
      await this.resolve(after);
    },
  },
  methods: {
    async resolve (src) {
      const fileProperties = await this.fileUsecase.getFileProperties([src]);
      this.fileName = fileProperties.fileName[0];
      this.blankOrDirect = fileProperties.blankOrDirect[0];
      this.fileUrl = fileProperties.fileUrl[0];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

a {
  white-space: normal;
}
</style>
